import styled from 'styled-components';
import { breakpoints } from '@bnnvara/breakpoints';
export const CardBody = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoints.md} {
    display: block;
    justify-content: normal;
    align-items: normal;
    background-color: ${({
  theme
}) => theme.base.white};
    padding: 0 20px;
    position: relative;
    height: 206px;
    margin: 8px 0 0 0;
  }
`;
export const CardMeta = styled.div`
  font-family: ${({
  theme
}) => theme.fonts.primary};
  font-size: 0.8rem;
  font-weight: 500;
  color: ${({
  theme
}) => theme.secondary.light};

  ${breakpoints.md} {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 20px 25px;
  }
`;
export const CardWrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;

  h2 {
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 16px;
    font-weight: bold;
    line-height: 1.27;
    word-break: break-word;
    color: ${({
  theme
}) => theme.base.black};
    margin: 0 0 8px;

    &:after {
      content: '';
      display: block;
      position: relative;
      top: 5px;
      width: 100%;
      height: 4px;
      background-color: ${({
  theme
}) => theme.primary.main};
      transform: scaleX(0);
      transition: all 0.2s ease-in-out;
      transform-origin: left center;
    }
  }

  &:hover {
    h2 {
      &:after {
        content: '';
        transform: scaleX(1);
        transform-origin: left center;
        transition: all 0.2s ease-in-out;
      }
    }
  }

  ${breakpoints.md} {
    border: 1px solid ${({
  theme
}) => theme.tertiary.main};
    border-top-width: 0px;
    flex-direction: column;
    justify-content: 'flex-end';

    h2 {
      font-size: 1.375rem;
      margin: 16px 0 0;
      padding-bottom: 16px;
    }
  }
`;
export const CardImageContainer = styled.div`
  width: 112px;
  height: 96px;
  flex-shrink: 0;
  background-color: ${({
  theme
}) => theme.tertiary.dark};
  margin-right: 8px;

  ${breakpoints.md} {
    position: relative;
    padding-bottom: 56.2%;
    width: 100%;
    height: auto;
  }
`;
export const CardImage = styled.img`
  object-fit: cover;
  width: 100%;
  height: 100%;

  ${breakpoints.md} {
    position: absolute;
  }
`;
export const CardTag = styled.div`
  display: none;
  ${breakpoints.md} {
    display: block;
    margin: -29px 0 0 20px;
    z-index: 1;
  }
`;
export const CardIconBox = styled.div`
  position: absolute;
  top: 0;
  left: 80px;
  height: 32px;
  width: 32px;
  background-color: ${({
  theme
}) => theme.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;

  ${breakpoints.md} {
    right: 0;
    left: auto;
  }
`;
export const Description = styled.p`
  display: none;

  ${breakpoints.md} {
    display: block;
    font-family: ${({
  theme
}) => theme.fonts.primary};
    font-size: 15px;
    line-height: 22px;
    color: ${({
  theme
}) => theme.base.black};
    margin-bottom: 25px;
    overflow: hidden;
  }
`;